import React, { useState, useEffect } from "react";
import { observer } from "mobx-react-lite";
import * as msTeams from "@microsoft/teams-js";
import useMsTeamsContext from "../hooks";
import { ReactChildrenProps } from "../../shared/types/ReactChildrenProps";

export interface InsideOriginTenantProps extends ReactChildrenProps {
    tenantId: string | undefined;
}

const InsideOriginTenant: React.FC<InsideOriginTenantProps> = (props: InsideOriginTenantProps) => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        var originTenants = process.env.REACT_APP_ORIGIN_TENANTS?.split(",").map((i) => i.toLowerCase());
        if (originTenants?.findIndex((i) => i === props.tenantId) ?? -1 >= 0) {
            msTeams.dialog.url.submit();
            return;
        }
        setIsLoading(false);
    }, []);

    if (isLoading) {
        return null;
    }

    return <>{props.children}</>;
};

export default InsideOriginTenant;
